import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { CampaignId } from './campaign-id';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Directive({
  selector: '[campaignRoute]'
})
export class CampaignRouteDirective implements OnInit {

  @Input() campaignRoute: string = '';

  constructor(
    private campaignId: CampaignId,
    private router: Router,
    private elementRef: ElementRef,
    private location: Location
  ) {
  }

  ngOnInit() {
    if (this.getUrl() === this.location.path()) {
      this.setActive();
    }
  }

  setActive() {
    for (const child of this.elementRef.nativeElement.parentNode.parentNode.children) {
      child.classList.remove('active');
    }
    this.elementRef.nativeElement.parentNode.classList.add('active');
  }

  getUrl(): string {
    return '/campaign/' + this.campaignId.getId() + this.campaignRoute;
  }

  @HostListener('click', [ '$event' ])
  onClick($event) {
    this.router.navigate([ this.getUrl() ]);
    this.setActive();
  }
}
